/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/star_medium'
export default icon
